import { render, staticRenderFns } from "./MerchantCoreSidebar.vue?vue&type=template&id=6e276367"
import script from "./MerchantCoreSidebar.vue?vue&type=script&lang=js"
export * from "./MerchantCoreSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports